import { STORE_RELATIONS_FALLBACK_TEXT } from '../../constants/storeConstants'
import { getStoreRelationBrandEntries } from '../../helpers/storeRelationAssignmentUtils'

const normalizeStoreRelationOptionText = (value) => {
  return typeof value === 'string' ? value.trim() : ''
}

export const buildStoreRelationEntityLabel = (entity) => {
  const dbRef = normalizeStoreRelationOptionText(entity?.db_ref)
  const name = normalizeStoreRelationOptionText(entity?.name)

  return [dbRef, name].filter(Boolean).join(' - ')
}

export const buildStoreRelationReadOnlyFilterOption = (id, label) => ({
  id,
  label: normalizeStoreRelationOptionText(label) || STORE_RELATIONS_FALLBACK_TEXT
})

export const buildStoreRelationBrandOptions = (relation) => {
  return getStoreRelationBrandEntries(relation)
    .map((item) => item?.brand)
    .filter(Boolean)
    .map((brand) => {
      const dbRef = normalizeStoreRelationOptionText(brand?.db_ref)
      const name = normalizeStoreRelationOptionText(brand?.name)
      const label = name || dbRef

      return {
        id: brand?.id || dbRef || name,
        db_ref: dbRef,
        name,
        label,
        raw: brand
      }
    })
    .filter((brandOption) => brandOption.id && brandOption.label)
}

export const mergeStoreRelationBrandOptions = (baseOptions = [], incomingOptions = []) => {
  const mergedOptions = new Map()

  ;[...baseOptions, ...incomingOptions]
    .filter(Boolean)
    .forEach((brandOption) => {
      const optionKey = brandOption?.id || brandOption?.db_ref || brandOption?.label

      if (optionKey && !mergedOptions.has(optionKey)) {
        mergedOptions.set(optionKey, brandOption)
      }
    })

  return Array.from(mergedOptions.values())
}

export const buildStoreRelationAssignmentRowOption = (row) => {
  const optionId = row?.id || row?.salesmanDbRef || row?.userLabel

  if (!optionId) return null

  return {
    id: optionId,
    db_ref: row?.salesmanDbRef || '',
    name: row?.userLabel || '',
    label: row?.userLabel || '',
    raw: null
  }
}

export const resolveStoreRelationAutocompleteSearchTerm = ({
  option,
  searchTerm = '',
  shouldDisableSearch = false
}) => {
  if (shouldDisableSearch) return ''
  if (option && searchTerm === option.label) return ''

  return searchTerm || ''
}
